import axios from 'axios';

const getHeaders = () => {
    const username = process.env.REACT_APP_POLICY_API_USERNAME || '';
    const password = process.env.REACT_APP_POLICY_API_PASSWORD || '';
    const authString = btoa(`${username}:${password}`);
    
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Basic ${authString}`
    };
};

export default axios.create({
    baseURL: process.env.REACT_APP_POLICY_API_BASE_URI || 'https://rvos-uat.mu-1-us-west-2.guidewire.net/coreapi/v5',
    headers: getHeaders(),
});

/**
 * Get policy by policy number
 * @param {string} policyNumber - The policy number (systemId) to search for
 * @returns {Promise} - Axios promise with policy data
 */
export const getPolicyByNumber = async (policyNumber) => {
    // In development, use proxy configured in setupProxy.js to avoid CORS issues
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    // In production, make direct request to API
    // CORS must be configured on the API server to allow requests from https://uat.rvos.com
    // REACT_APP_POLICY_API_BASE_URI should include /coreapi/v5 (e.g., https://rvos-uat.mu-1-us-west-2.guidewire.net/coreapi/v5)
    const baseURL = isDevelopment 
        ? '' // Use empty baseURL to use proxy in development
        : (process.env.REACT_APP_POLICY_API_BASE_URI || 'https://rvos-uat.mu-1-us-west-2.guidewire.net/coreapi/v5');
    
    // Use query parameter policyNumber
    const apiPath = isDevelopment
        ? `/api/policies?policyNumber=${encodeURIComponent(policyNumber)}` // Use proxy in development
        : `/policies?policyNumber=${encodeURIComponent(policyNumber)}`; // Direct API call in production (baseURL already includes /coreapi/v5)
    
    const api = axios.create({
        baseURL: baseURL,
        headers: getHeaders(),
        timeout: 30000, // 30 seconds timeout
        validateStatus: function (status) {
            // Accept all status codes (including 404) so we can handle them in the component
            return status >= 200 && status < 600;
        },
    });
    
    return api.get(apiPath);
};

